import offersService from "../../services/backend/offersService";

export default {
  state: {
    idOffertaAttiva: 0,
    nrOffertaAttiva: "",
    nameOffertaAttiva: ""
  },
  getters: {
    getIdOffertaAttiva: state => {
      return state.idOffertaAttiva;
    },
    getNrOffertaAttiva: state => {
      return state.nrOffertaAttiva;
    },
    getNameOffertaAttiva: state => {
      return state.nameOffertaAttiva;
    }
  },
  mutations: {
    setIdOffertaAttiva(state, newId) {
      offersService.getOffer(newId).then(offerta => {
        if (offerta != null) {
          state.idOffertaAttiva = newId;
          state.nrOffertaAttiva = offerta.offerNumber;
          state.nameOffertaAttiva = offerta.offerDescription;
        }
      });
    },
    setNrOffertaAttiva(state, offerNumber) {
      state.nrOffertaAttiva = offerNumber;
    },
    setNameOffertaAttiva(state, offerDescription) {
      state.nameOffertaAttiva = offerDescription;
    },
    resetOffertaAttiva(state) {
      state.idOffertaAttiva = 0;
      state.nrOffertaAttiva = "";
      state.nameOffertaAttiva = "";
    }
  }
};
